import mapboxgl from "mapbox-gl";
import { CoamAreaFeature } from "../api/coamArea";
import { useRagMarkersLayer } from "../hooks/useRagMarkersLayer";

interface RagMarkersLayerProps {
  map: mapboxgl.Map | null;
  features: CoamAreaFeature[];
  onSelect?: (feature: CoamAreaFeature) => void;
}

export const RagMarkersLayer = ({ map, features, onSelect }: RagMarkersLayerProps) => {
  useRagMarkersLayer({ map, features, onSelect });
  return null;
};

